import { type GetUsersInfiniteQueryParams, useGetUsersInfinite } from '@pba/react-chat-core';
import { createChatUser } from 'models';
import { useMemo } from 'react';

export const useChatUsersInfiniteQuery = ({ filter, options, pagination }: GetUsersInfiniteQueryParams) => {
  const query = useGetUsersInfinite({
    filter,
    options,
    pagination,
  });

  const data = useMemo(
    () =>
      query.data
        ? {
            ...query.data,
            pages: query.data.pages.map((page) => page.map((user) => createChatUser(user))),
          }
        : undefined,
    [query.data],
  );

  return useMemo(
    () => ({
      ...query,
      data,
    }),
    [data, query],
  );
};
